import IconClose from 'images/icon-close-blue.svg'

import cn from 'classnames'

import styles from './styles.module.scss'

export default function PopupCloseBtn({ onClose, className = '' }) {
  return (
    <button className={cn(styles.btn, className)} type="button" onClick={onClose}>
      <img width={14} height={14} src={IconClose} alt="close" />
    </button>
  )
}
